export default {
  NEXT_PUBLIC_CORTEX_API_URL:
    process.env.NEXT_PUBLIC_CORTEX_API_URL || 'http://localhost:4000',
};
